var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.751,
    height: 149.77,
    viewBox: "0 0 161.751 149.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M1419.075,146.774h-5.99v-5.991a3,3,0,0,0-3-3h-18.25l-3.08-26.958h51.284a9,9,0,0,0,8.986-8.986V14.977a9,9,0,0,0-8.986-8.987h-131.8a9,9,0,0,0-8.986,8.987v86.866a9,9,0,0,0,8.986,8.986h51.284l-3.08,26.958H1338.2a3,3,0,0,0-3,3v5.991h-5.991v-5.991a9,9,0,0,1,8.986-8.986h12.9l1.711-14.977h-44.569a14.994,14.994,0,0,1-14.977-14.977V14.977A15,15,0,0,1,1308.246,0h131.8a15,15,0,0,1,14.977,14.977v86.866a14.994,14.994,0,0,1-14.977,14.977h-44.568l1.711,14.977h12.9a9,9,0,0,1,8.986,8.986Z",
    transform: "translate(-1293.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 104.839,
    height: 5.991,
    transform: "translate(26.959 143.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 5.991,
    height: 5.991,
    transform: "translate(137.788 143.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 11.982,
    height: 5.991,
    transform: "translate(62.903 110.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 5.991,
    height: 5.991,
    transform: "translate(80.875 110.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 155.76,
    height: 5.991,
    transform: "translate(2.995 92.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 5.991,
    height: 5.991,
    transform: "translate(95.853 20.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 5.991,
    height: 5.991,
    transform: "translate(107.834 20.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 5.991,
    height: 5.991,
    transform: "translate(119.816 20.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1391.789,103.806h-.822a11.159,11.159,0,0,1-2-22.138l21.313-3.873a3.016,3.016,0,0,0,2.475-2.969,7.18,7.18,0,0,0-1.1-3.885,14.188,14.188,0,0,1-1.9-7.331,10.739,10.739,0,0,1,10.727-10.726h19.125a24.067,24.067,0,0,1,2.779,47.973,492.625,492.625,0,0,1-50.6,2.948m28.7-44.931a4.74,4.74,0,0,0-4.736,4.736,8.338,8.338,0,0,0,1.222,4.572,13.012,13.012,0,0,1,1.773,6.643,9,9,0,0,1-7.392,8.86l-21.313,3.873a5.17,5.17,0,0,0,.925,10.256h.822a485.25,485.25,0,0,0,49.883-2.908,18.075,18.075,0,0,0-2.059-36.032Z",
    transform: "translate(-1325.891 -19.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M1501.362,128.433l-2.832-5.277a30.359,30.359,0,0,0,14.655-17.955l5.739,1.708a36.364,36.364,0,0,1-17.563,21.524",
    transform: "translate(-1370.644 -39.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1361.056,67.157h-38.94V19.231h59.907V49.185h-20.967Zm-32.95-5.991h26.958V43.194h20.968V25.222h-47.926Z",
    transform: "translate(-1304.143 -7.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 11.982,
    height: 5.991,
    transform: "translate(41.935 35.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 11.982,
    height: 5.991,
    transform: "translate(20.967 35.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1346.078,128.55h-23.963V110.578h23.963Zm-17.972-5.991h11.982v-5.991h-11.982Z",
    transform: "translate(-1304.143 -41.683)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/design-icon.b4b0e96c5853fc84e33a0efd54c91364.svg";
export { ForwardRef as ReactComponent };